module.exports = __webpack_public_path__ + "img/console-tables.138ce10.png";